import { Component, computed, input, output } from '@angular/core';
import { CarouselComponent } from '../carousel/carousel.component';
import { MapComponent } from '../map/map.component';
import { StarRatingComponent } from '../star-rating/star-rating.component';
import { StoreService } from '../../../store/store.service';
import { AmenitiesListComponent } from '../amenities-list/amenities-list.componet';

@Component({
  standalone: true,
  imports: [
    CarouselComponent,
    StarRatingComponent,
    MapComponent,
    AmenitiesListComponent
  ],
  selector: 'app-hotel-details',
  templateUrl: './hotel-details.component.html',
  styleUrl: './hotel-details.component.scss',
})

export class HotelDetailsComponent {
  public readonly isOpen = input.required<boolean>();
  public readonly selectedHotel = input<any>(null);
  public readonly closeModalEvent = output<void>();

  public readonly hotelDetailsImgs = computed(() => {
    const hotel = this.selectedHotel();
    if (hotel?.hotelImagesList?.length) {
      return hotel.hotelImagesList.map((e: any) => ({
        src: e?.extraLargeImageURL,
        alt: e?.altText,
      }));
    } else if (hotel?.imageInfo?.length) {
      return hotel.imageInfo.map((e: any) => ({
        src: e?.urls?.large || e?.urls?.yankee_large || e?.urls?.thumb_large || e?.urls?.thumb_medium,
        alt: e?.alt_text || hotel.name,
      }));
    } else {
      return [];
    }
  });
  public readonly featuredAmenities = computed(() => {
    const hotel = this.selectedHotel();
    const locale = this._storeSvc.userStore.langObj()?.code;
    const amenities = hotel?.featuredAmenities || hotel?.hotelAmenities;
    return Array.isArray(amenities)
      ? amenities.map((e: any) => ({
          ...e,
          name: e.nameByLang && locale && locale in e.nameByLang
            ? e.nameByLang[locale]
            : e.name
        }))
      : [];
  });
  public readonly commonRoomAmenities = computed(() => {
    const hotel = this.selectedHotel();
    const locale = this._storeSvc.userStore.langObj()?.code;
    const amenities = hotel?.commonRoomAmenities || hotel?.commonAmenities;
    return Array.isArray(amenities)
      ? amenities.map((e: any) => ({
          ...e,
          name: e.nameByLang && locale && locale in e.nameByLang
            ? e.nameByLang[locale]
            : e.name
        }))
      : [];
  });

  constructor(
    public readonly _storeSvc: StoreService,
  ) { }

  public getFullAddress(): string {
    const addr = this.selectedHotel()?.address;
    if (addr) {
      const parts = [
        addr.street1,
        ...(addr.street2 ? [addr.street2] : []),
        addr.city,
        addr.state,
        addr.country,
        ...(addr.zip_code ? [addr.zip_code] : []),
      ];
      return parts.filter(Boolean).join(', ');
    }
    return '';
  }
}
